import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddContentLayer from "../components/AddContentLayer";

const EditContentPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Edit Content Details' />

        {/* AddContentLayer */}
        <AddContentLayer />
      </MasterLayout>
    </>
  );
};

export default EditContentPage;